import HomeSerious from "./HomeSerious"

export default HomeSerious